import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageChangeService {
    language = 'en';
    private messageSource = new BehaviorSubject('english');
    currentLanguage = this.messageSource.asObservable();

    constructor(private translate: TranslateService, private stateStorageService: StateStorageService) {
        this.refreshLanguage();
    }

    changeLanguage(message: string) {
        this.messageSource.next(message);
        this.translate.setDefaultLang(message);
        this.translate.use(message);
    }

    onLanguageChange(event) {
        let lan = event?'de':'en';
        this.stateStorageService.resetLanguageKey();
            this.stateStorageService.storeLanguageKey(lan);
            this.changeLanguage(lan);
    }
    refreshLanguage(){
        this.onLanguageChange(this.stateStorageService.getLanguageKey()  === 'de' ?true:false);
    }
}
